<div class="container-fluid audit-container" style="background-color: var(--gl-body-background-color);">
  <div class="row">
    <div class="col-12 d-flex flex-column" style="padding: 0.8rem; position: relative;">
      <app-auditform (selectedPlanEvent)="onPlanSelection($event)"></app-auditform>
    </div>
    <div class="col-12" style="padding: 0.8rem; position: relative;">
      <app-auditresult #subscritionDetails (eventDisplayGroup)="eventDisplayGroup($event)"
        (selectedActivityEvent)="onActivitySelection($event)"></app-auditresult>
    </div>
  </div>

  <app-auditdetail (onHideEvent)="onHideDisplayGroup($event)" [display]="displayGroup" [activity]="activity" [properties]="properties"
    [subject_type]="subject_type" [message]="descriptionMessage"></app-auditdetail>

</div>

<toast-license *appHasPermission="'license_module'"></toast-license>
<dialog-license *appHasPermission="'license_module'"></dialog-license>